// extracted by mini-css-extract-plugin
module.exports = {"Homepage":"homepage_Homepage__3exgo"};